import Popup from 'components/Popup/Popup'
import { Button, BUTTON_TYPES } from 'components/Button'
import { Typography, TYPOGRAPHY_WEIGHT } from 'components/Typography'
import { BTN_TXT } from '../../../../../constants'
import { TUpgradeModal } from './types'
import { setLoading } from '../../../../../redux/store/common/slice'
import { useDispatch } from 'react-redux'
import { upgradeVendor } from '../api'
import { notification } from '../../../../../components/Notification'
import { useVendorsPagePopup } from '../../Providers/VendorsPagePopupProvider'

export const UpgradeModal = ({ callback }: TUpgradeModal) => {
  const dispatch = useDispatch()

  const {
    upgradeToFullAccessPopup: { state, actions }
  } = useVendorsPagePopup()

  const { uuid } = state.payload

  const onCancel = () => actions.close()

  const onUpgrade = async () => {
    if (!uuid) return
    try {
      dispatch(setLoading(true))
      await upgradeVendor(uuid)
      notification.success({
        message: `Vendor has been successfully upgraded.`
      })
      onCancel()
      callback()
    } catch (e) {
      console.error(e)
    } finally {
      dispatch(setLoading(false))
    }
  }

  return (
    <Popup
      {...state}
      onCancel={onCancel}
      width={442}
      footer={
        <>
          <Button onClick={onCancel} type={BUTTON_TYPES.DEFAULT} upperCase>
            {BTN_TXT.CANCEL}
          </Button>
          <Button type={BUTTON_TYPES.PRIMARY} upperCase onClick={onUpgrade}>
            {BTN_TXT.UPGRADE}
          </Button>
        </>
      }
    >
      <Typography.Headline6 weight={TYPOGRAPHY_WEIGHT.NORMAL}>
        Changing access to Full Access enables this Vendor to participate in
        Contracts and Bidding workflows.
      </Typography.Headline6>
    </Popup>
  )
}
